import { AxiosRequestConfig } from 'axios';

// const methodNames = [
//     'config',
//     'trading/networks',
//     'task/getAllUserTasksHeaders',
//     'task/info',
//     'file/delete',
//     'file/upload-file',
//     'file/upload-hints-file',
//     'filters/base/move',
//     'filters/base',
//     'filters/base/individual',
//     'filters/kviCart',
//     'filters/kviCart/individual',
//     'filters/promo',
//     'filters/promo/individual',
//     'ftp/load',
//     'ftp/getFtpRevaluationsParams',
//     'ftp/reset',
//     'ftp/save',
//     'ftp/saveFtpRevaluationsParams',
//     'kvi-carts/addProductsToKviCart',
//     'kvi-carts/loadAllKviCarts',
//     '/load-events/checkCross',
//     '/load-events/checkIdentical',
//     '/load-events',
//     '/load-events/getAllFilters',
//     '/load-events/saveCalcParams',
//     '/load-events/loadCalcParams',
//     'money/load',
//     'money/save',
//     'revaluation-quotas',
//     'revaluation-quotas/getQuotasList',
//     'revaluation-quotas/getDefaultQuota',
//     'revaluation-quotas/manualSendApprovedRevaluationsToFtp',
//     'revaluation-quotas/queue',
//     'revaluation-quotas/getRevaluationCheckedSalesPointsByTradingId/',
//     'revaluation-quotas/saveRevaluationTradingsAndSalePoints',
//     'revaluation-quotas/queue/products/internal-code',
//     'revaluation-quotas/queue/products/filters',
//     'revaluation-quotas/queue/product/custom-sending-date',
//     'revaluation-quotas/columns',
//     'revaluation-quotas/filters',
//     'revaluation-quotas/checkApprovedRevaluationsTasks',
//     'rounding/saveRulesParams',
//     'rounding/upload-rounding-rule',
//     'scenario-analysis/save',
//     'scenario-analysis/load',
//     'scheduleCalc/checkCrossSchedule',
//     'scheduleCalc/checkIdenticalSchedule',
//     'scheduleCalc',
//     'task/add',
//     'task/packageKviCart',
//     'task/kviSearch',
//     'task/priceCorridor',
//     'task/dataRange',
//     'task/result/generate',
//     'task/findTask',
//     'task/promo',
//     'task/packageCalc',
//     'task/packageKviRecommends',
//     'task/packagePromo',
//     'task/packagePromoRecommends',
//     'task/checkOKRBCodes',
//     'task/checkOKRBCode',
//     'task/list',
//     'task/getUsersFio',
//     'task/getAllTaskIds',
//     'task/minRetailPrice',
//     'task/package/count',
//     'task/cancelTask',
//     'task/restartTask',
//     'task/checkUnfinishReports',
//     'task/checkCancelReports',
//     'task/stop-brut-force',
//     'task/sendToFtp',
//     'task/rejectTasks',
//     'task/approveTasks',
//     'task/packageScenarioCalc',
//     'task/result',
//     'task/delete',
//     'omnichannel-strategies/intersections',
//     'omnichannel-strategies',
//     'omnichannel-strategies/list',
//     'omnichannel-strategies/find-missed-params',
//     'kvi-carts/delete/id',
//     'trading/networks/update/name',
//     'kvi-carts/add',
//     'file/list',
//     'hints/load-hints/'
// ]

export const addUserIdToData = ({ url, params }: AxiosRequestConfig, userId: number) => {
    // if (!url) return;
    //
    // let urlTokens = url.split('api/');
    // let methodName;
    // if (urlTokens.length === 1) {
    //     methodName = url
    // } else {
    //     methodName = urlTokens[1];
    // }
    //
    //
    // if (!methodNames.includes(methodName)) return;

    return { ...params, userId };
}
